/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export default defineMessages({
  panelIllustration: {
    id: 'ccm.panel.illustration',
    defaultMessage: 'Cloud connected illustration',
  },
  learnMoreAriaLabel: {
    id: 'ccm.learnMore.ariaLabel',
    defaultMessage: 'Learn more about connected clusters',
  },
  zeroCCMClustersTitle: {
    id: 'ccm.zeroCCMClusters.title',
    defaultMessage: 'Connect your self-managed cluster',
  },
  zeroCCMClustersBody: {
    id: 'ccm.zeroCCMClusters.body',
    defaultMessage:
      'Connect your self-managed cluster to Elastic Cloud to use the cloud services such as AutoOps, Elastic ' +
      'Inference Service and more. <link>Learn more</link>',
  },
  connectClusterButton: {
    id: 'ccm.connectCluster.button',
    defaultMessage: 'Connect Cluster',
  },
  ccmClustersTileTitle: {
    id: 'ccm.ccmClustersTile.title',
    defaultMessage: 'Connected Clusters',
  },
  titlePopover: {
    id: 'ccm.titlePopover',
    // TODO: https://github.com/elastic/cloud/issues/142670 this is a generated copy. Replace with the actual copy when available
    defaultMessage:
      'Connected Clusters allow you to connect your self-managed clusters to Elastic Cloud. ' +
      'This enables you to use cloud services such as AutoOps, Elastic Inference Service, and more. ' +
      'You can also monitor and manage your clusters from the Elastic Cloud console. {link}',
  },
})
